import { render, staticRenderFns } from "./UploadCommon.vue?vue&type=template&id=582d050d&scoped=true&"
import script from "./UploadCommon.vue?vue&type=script&lang=js&"
export * from "./UploadCommon.vue?vue&type=script&lang=js&"
import style0 from "./UploadCommon.vue?vue&type=style&index=0&id=582d050d&prod&scoped=true&lang=css&"
import style1 from "./UploadCommon.vue?vue&type=style&index=1&id=582d050d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d050d",
  null
  
)

export default component.exports